import React from 'react';
import './StarRating.scss';

interface StarRatingProps {
  rating: number; // 1-5
  size?: 'small' | 'medium' | 'large';
}

const StarRating: React.FC<StarRatingProps> = ({ rating, size = 'medium' }) => {
  const stars = [];
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;

  for (let i = 0; i < 5; i++) {
    if (i < fullStars) {
      stars.push(
        <span key={i} className={`star star-filled star-${size}`}>
          ★
        </span>
      );
    } else if (i === fullStars && hasHalfStar) {
      stars.push(
        <span key={i} className={`star star-half star-${size}`}>
          ★
        </span>
      );
    } else {
      stars.push(
        <span key={i} className={`star star-empty star-${size}`}>
          ★
        </span>
      );
    }
  }

  return <div className="star-rating">{stars}</div>;
};

export default StarRating;

